import React from "react";
import { useTranslation } from "react-i18next";
import map from "lodash/map";
import uniq from "lodash/uniq";
import PropTypes from "prop-types";
import { RillContext, useRillContext } from "../rill/RillReact/share/base";

function Pagination({ total, pageSize }) {
  const { t } = useTranslation("common");
  const { locals } = useRillContext();

  const {
    query: { page, planMode },
  } = locals;
  const pages = Math.ceil(total / pageSize);
  const activePage = parseInt(page, 10) || 1;
  // Don't show pagination if there are no pages.
  if (pages <= 1) return <noscript />;

  // Build query params preserving planMode if it exists
  const buildQueryString = (pageNum) => {
    const params = new URLSearchParams({ page: pageNum });
    if (planMode) {
      params.set("planMode", planMode);
    }
    return `/actions/refresh?${params.toString()}`;
  };

  return (
    <div className="Pagination">
      {pages <= 1 ? undefined : (
        <a
          onClick={(e) => {
            if (activePage - 1 <= 0) e.preventDefault();
          }}
          href={buildQueryString(activePage - 1)}
          role="button"
          data-button-type="secondary"
          disabled={activePage - 1 <= 0}
        >
          <img
            src="/img/new-icons/arrow-square-left-gradient.svg"
            alt={t("pagination.prevPage")}
          />
          <span>{t("pagination.previous")}</span>
        </a>
      )}

      <div>
        {pages <= 1
          ? undefined
          : map(paginate(pages, activePage), (page, i) => {
              if (page == null)
                if (i > 2 || activePage > 4) {
                  return <span key={String(page) + i}>...</span>;
                } else {
                  return <span key={String(page) + i} />;
                }
              const active = page === activePage;
              return (
                <a
                  key={page}
                  href={buildQueryString(page)}
                  role="button"
                  data-button-type={active ? "outline" : "secondary"}
                >
                  {page}
                </a>
              );
            })}
      </div>
      {pages <= 1 ? undefined : (
        <a
          onClick={(e) => {
            if (activePage + 1 > pages) e.preventDefault();
          }}
          href={buildQueryString(activePage + 1)}
          role="button"
          data-button-type="secondary"
          disabled={activePage + 1 > pages}
        >
          <span>{t("pagination.next")}</span>
          <img
            src="/img/new-icons/arrow-square-right-gradient.svg"
            alt={t("pagination.nextPage")}
          />
        </a>
      )}
    </div>
  );
}

Pagination.defaultProps = { total: 0, pageSize: 100 };

function paginate(length, selected) {
  var all = uniq([
    0,
    1,
    selected - 2,
    selected - 1,
    selected,
    selected + 1,
    selected + 2,
    length - 2,
    length - 1,
    length,
  ]).filter((page) => page > 0 && page <= length);

  var i,
    cur,
    prev = 0;
  for (i = 1; i < all.length - 1; i++) {
    cur = all[i];
    if (cur - prev !== 1) all.splice(i++, 0, undefined);
    prev = cur;
  }

  return all;
}

export default Pagination;
